import { DashworksReconnectButton } from './DashworksReconnectButton';
import { AppConnectionStatuses } from '../../../../constants/appConnectionStatuses';
export const DashworksReconnectionConfig = {
  reconnectButton: DashworksReconnectButton,
  statusesForDisplaying: [AppConnectionStatuses.UPDATE_AVAILABLE, AppConnectionStatuses.DISCONNECTED]
};